import React from "react";


export default function Brand({ props }) {
    return (
        <div className="brand">
            <img className="brand-svg-auth mx-auto d-block" src={'/' + process.env.PUBLIC_URL + global.config.brand_url} alt="logo" />
        </div>
    )
}